var map = {
	"./bbc54yyk/login_bg.jpg": "a6c7",
	"./chaoxinxing/login_bg.jpg": "d14d",
	"./ecshopx/login_bg.jpg": "bc09",
	"./onex/login_bg.jpg": "8b3b",
	"./yyk/login_bg.jpg": "fc06"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "10d9";